<template>

    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <label for="name">Keadaan Material </label>
                <input type="text" v-model="model.name" class="form-control" readonly>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            model: {
                name: this.detail?.name,
                id: this.detail?.id,
            }
        }
    },
    methods: {
        resetModel() {
            this.model = { name: '', id: '', }
        },
        editMode(item) {
            this.model.name = item.name
            this.model.id = item.id
        }
    }
}
</script>